import { CompService } from './../../../shared/services/societe-linked/comp.service';
import { NaService } from '../../../shared/services/simple/na.service';
import { NaModel } from '../../../shared/models/simple-types/na.model';
import { Ca2Service } from './../../../shared/services/societe-linked/ca2.service';
import { BcModel } from './../../../shared/models/societe-linked/bc/bc.model';
import { SimpleQueryResponse } from '../../../shared/dtos/simpleQueryResponse';
import { BpModel } from 'src/app/shared/models/societe-linked/bp/bp.model';
import { BpComponentsService } from './../../bp/bp-components.service';
import { BpLineModel } from 'src/app/shared/models/societe-linked/bp/bp-line.model';
import { NTHFlag, parseFlags, stringifyFlags } from '../../../shared/constants/flag';
import { debounceTime } from 'rxjs/operators';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { UtilisateurModel } from './../../../shared/models/utilisateur/utilisateur.model';
import { UserService } from './../../../shared/services/user.service';
import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { FilterBcDTO } from 'src/app/shared/dtos/filterBcDTO';
import { CondReglModel } from 'src/app/shared/models/simple-types/cond-regl.model';
import { ModeReglModel } from 'src/app/shared/models/simple-types/modeRegl.model';
import { SocieteModel } from 'src/app/shared/models/simple-types/societe.model';
import { BcService } from 'src/app/shared/services/bc/bc.service';
import { StateService } from 'src/app/shared/services/state.service';
import { FiltreService } from '../../filtre.service';
import { CompModel } from 'src/app/shared/models/societe-linked/comp.model';
import { SiteModel } from 'src/app/shared/models/societe-linked/site.model';
import { Ca1Model } from 'src/app/shared/models/societe-linked/ca1.model';
import { Ca2Model } from 'src/app/shared/models/societe-linked/ca2.model';
import { FournisseurModel } from 'src/app/shared/models/societe-linked/fournisseur.model';
import { SiteService } from 'src/app/shared/services/societe-linked/site.service';
import { Ca1Service } from 'src/app/shared/services/societe-linked/ca1.service';
import { FournisseurService } from 'src/app/shared/services/societe-linked/fournisseur.service';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { SocieteService } from 'src/app/shared/services/simple/societe.service';
import { BcValidationModel } from 'src/app/shared/dtos/bcValidationModel';
import { ModalChargementComponent } from 'src/app/shared/components/modals/modal-chargement/modal-chargement.component';
import { saveAs } from 'file-saver';
import { SpinnerModalComponent } from 'src/app/shared/components/modals/spinner/spinner-modal.component';
import { LivraisonBcService } from 'src/app/shared/services/bc/livraison-bc.service';
import { BcLineModel } from 'src/app/shared/models/societe-linked/bc/bc-line.model';
import { ModalRechercheFournisseurComponent } from '../modals/modal-recherche-fournisseur/modal-recherche-fournisseur.component';
import { GenericLibelleService } from 'src/app/shared/services/basic/generic-libelle.service';
import { BasicModel } from 'src/app/shared/models/basic/basic.model';
import { CategorieService } from 'src/app/shared/services/simple/categorie.service';
import { CategorieModel } from 'src/app/shared/models/simple-types/categorie.model';
import { DefinitionNamesBC, DefinitionTypeBC } from 'src/app/shared/typeBCDefinitions';

@Component({
  selector: 'app-liste-bc',
  templateUrl: './liste-bc.component.html',
  styleUrls: ['./liste-bc.component.scss']
})

export class ListeBcComponent implements OnInit, OnDestroy {
  range = new UntypedFormGroup({
    start: new UntypedFormControl(),
    end: new UntypedFormControl()
  });
  societes: SocieteModel[];
  comps: CompModel[];
  sites: SiteModel[];
  sitesLiv: SiteModel[];
  ca1s: Ca1Model[];
  ca2s: Ca2Model[];
  bcsEnd: BcModel[];
  bcsStart: BcModel[];
  nasStart: NaModel[];
  nasEnd: NaModel[];
  user: string;
  users: UtilisateurModel[] = [];
  validors: UtilisateurModel[] = [];
  fournisseurs: FournisseurModel[];
  categories: CategorieModel[];
  modeRegls: ModeReglModel[];
  condRegls: CondReglModel[];
  myOpenOrderCount = 0;
  matDataSourceBC: MatTableDataSource<BcModel>;
  selection = new SelectionModel<BcModel>(false, []);
  filtreData: FilterBcDTO = new FilterBcDTO();
  bcList: BcModel[] = [];
  simpleQueryBcResponse = new SimpleQueryResponse<BcModel>();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  society: SocieteModel;
  filteredOptions: Observable<string[]>;
  public FlagEnum = NTHFlag;
  private filteredSubscribe: Subscription;
  isCreateBp = false;
  isListAValide = false;
  title = 'Liste des bons de commande';
  public options = [
    { value: 'None', id: 0 },
    { value: 'Some', id: 1 },
    { value: 'All', id: 2 },
  ];
  bp: BpModel = null;
  bpLines: BpLineModel[] = [];
  currentRoute: any;
  selectedBcsChild: BcModel[] = [];
  listStatus = ['Brouillon', 'A Valider', 'Validation 1', 'Validation 2', 'Validation 3', 'Validation 4', 'Validé', 'Clos'];
  listStatusUpdated = new BehaviorSubject<string[]>(this.listStatus);
  listTypesBC = Object.values(DefinitionNamesBC);
  listTypesBCUpdated = new BehaviorSubject<string[]>(this.listTypesBC);
  flagList = ['Total', 'Partiel', 'Aucun'];
  bFlagList = new BehaviorSubject<string[]>(this.flagList);
  fFlagList = new BehaviorSubject<string[]>(this.flagList);
  lFlagList = new BehaviorSubject<string[]>(this.flagList);
  dFlagList = new BehaviorSubject<string[]>(this.flagList);
  vFlagList = new BehaviorSubject<string[]>(this.flagList);
  aFlagList = new BehaviorSubject<string[]>(this.flagList);
  pFlagList = new BehaviorSubject<string[]>(this.flagList);

  constructor(public dialog: MatDialog,
              private router: Router,
              private titleService: Title,
              private userService: UserService,
              public siteService: SiteService,
              public bcService: BcService,
              public categorieService: CategorieService,
              public ca1Service: Ca1Service,
              public ca2Service: Ca2Service,
              public naService: NaService,
              public compService: CompService,
              public fournisseurService: FournisseurService,
              private state: StateService,
              private filtreService: FiltreService,
              private bpComponentsService: BpComponentsService,
              private societeService: SocieteService,
              private detector: ChangeDetectorRef,
              private livraisonBcService: LivraisonBcService) {
              }

  ngOnDestroy(): void {
    this.filteredSubscribe.unsubscribe();
  }

  onChange(event): void {
    this.filtreData.pageNumber = 0;
    this.filtreService.changeFiltre(this.filtreData);
  }

  loadData(value: string, service: GenericLibelleService<BasicModel>, modelString: string): void {
    if (value) {
      service.getAllFiltred(value, this.filtreData.societe ? this.filtreData.societe.id : null).subscribe(objs => {
        this[modelString] = objs;;
      });
    } else {
      this[modelString] = [];
    }
  }

  onFiltreChange(event, state): void {
    switch (state) {
      case 'Statut':
        this.filtreData.status = event;
        break;
      case 'Createur':
        this.filtreData.idCreateur = event;
        break;
      case 'Valideur':
        this.filtreData.idValidateur = event;
        break;
      case 'BC bloqués':
        this.filtreData.fLitige = parseFlags(event);
        this.filtreData.bBloque = this.parseBool(event);
        break;
      case 'BC facturés':
        this.filtreData.fHasBp = parseFlags(event);
        break;
      case 'BC livrés':
        this.filtreData.fLivre = parseFlags(event);
        break;
      case 'BC déprovisionnés':
        this.filtreData.fDeprovis = parseFlags(event);
        break;
      case 'BC validés':
        this.filtreData.fValide = parseFlags(event);
        break;
      case 'BC annulés':
        this.filtreData.fAnnule = parseFlags(event);
        break;
      case 'BC provisionnés':
        this.filtreData.fProvis = parseFlags(event);
        break;
      case 'TypeBC':
        this.filtreData.typesBC = DefinitionTypeBC.typesBCNamesToTypes(event);
        break;
    }
    this.onChange(event);
  }

  clearFiltre(): void {
    const type = this.filtreData.type;
    this.filtreData = new FilterBcDTO();
    this.filtreData.pageNumber = 0;
    this.filtreData.type = type;
    this.filtreService.changeFiltre(this.filtreData);
  }

  ngOnInit(): void {
    var index = this.selectedBcsChild.length;
    if(index) {
      this.selectedBcsChild.splice(0,index);
    }
    this.currentRoute = this.router.url;
    if (this.currentRoute === '/select-bc-for-create-bp') {
      this.isCreateBp = true;
    }
    if (this.isCreateBp) {
      this.titleService.setTitle('SACHA - Sélection BC pour créer BP ');
    } else {
      this.titleService.setTitle('SACHA - Liste BC ');
    }
    this.detector.detectChanges();
    this.state.society.subscribe(result => {
      this.society = result;
      if (result) {
        this.filtreData.idSociety = this.society.id;
      }
    });
    this.state.user.subscribe(result => {
      this.user = result;
    });
    this.filteredSubscribe = this.filtreService.filtre.pipe(debounceTime(700)).subscribe(result => {
      this.filtreData = result;
      this.listStatusUpdated.next(result.status);
      this.listTypesBCUpdated.next(DefinitionNamesBC.typesBCTypesToNames(result.typesBC));
      let bFlags = stringifyFlags(result.fLitige).concat(this.stringifyBool(result.bBloque));
      bFlags = bFlags.filter((item, index) => bFlags.indexOf(item) === index);
      this.bFlagList.next(bFlags);
      this.fFlagList.next(stringifyFlags(result.fHasBp));
      this.dFlagList.next(stringifyFlags(result.fDeprovis));
      this.aFlagList.next(stringifyFlags(result.fAnnule));
      this.vFlagList.next(stringifyFlags(result.fValide));
      this.pFlagList.next(stringifyFlags(result.fProvis));
      this.lFlagList.next(stringifyFlags(result.fLivre));
      this.title = 'Liste des bons de commande ';
      switch (this.filtreData.type) {
        case 'duplique': {
          this.title = this.title + 'à dupliquer';
          this.isListAValide = false;
          break;
        }
        case 's_brouillons': {
          this.title = this.title + 'brouillons';
          this.isListAValide = false;
          break;
        }
        case 'mes_BC_brouillons': {
          this.title = this.title + ': mes BC brouillons';
          this.isListAValide = false;
          break;
        }
        case 's_en_attente': {
          this.title = this.title + 'en attente de validation';
          this.isListAValide = false;
          break;
        }
        case 'mes_BC_en_attente': {
          this.title = this.title + ': mes BC en attente de validation';
          this.isListAValide = false;
          break;
        }
        case 's_refusés': {
          this.title = this.title + 'refusés';
          this.isListAValide = false;
          break;
        }
        case 'mes_BC_refusés': {
          this.title = this.title + ': mes BC refusés';
          this.isListAValide = false;
          break;
        }
        case 's_valide_a_suivre': {
          this.title = this.title + 'validés à suivre';
          this.isListAValide = false;
          break;
        }
        case 'mes_BC_valide_a_suivre': {
          this.title = this.title + ': mes BC validés à suivre';
          this.isListAValide = false;
          break;
        }
        case 's_valide_recemment': {
          this.title = this.title + 'validés ces dernières 48 heures';
          this.isListAValide = false;
          break;
        }
        case 'mes_BC_valide_recemment': {
          this.title = this.title + ': mes BC validés ces dernières 48 heures';
          this.isListAValide = false;
          break;
        }
        case 's_a_receptionner': {
          this.title = this.title + 'à réceptionner';
          this.isListAValide = false;
          break;
        }
        case 'mes_BC_a_receptionner': {
          this.title = this.title + ': mes BC à réceptionner';
          this.isListAValide = false;
          break;
        }
        case 's_valide_bp': {
          this.title = this.title + 'validés';
          this.isListAValide = false;
          break;
        }
        case 'mes_BC_valide_bp': {
          this.title = this.title + ': mes BC validés';
          this.isListAValide = false;
          break;
        }
        case 'v_valide_recemment': {
          this.title = this.title + 'traités ses dernières 48 heures';
          this.isListAValide = false;
          break;
        }
        case 'v_en_attente': {
          this.title = this.title + 'en attente de validation';
          this.isListAValide = true;
          break;
        }
        case 'v_traite_recemment': {
          this.title = this.title + 'validés non clos';
          this.isListAValide = false;
          break;
        }
        case 'v_bloques': {
          this.title = this.title + 'bloqués';
          this.isListAValide = false;
          break;
        }
        case 'Mes_Bc': {
          this.title = this.title + ': Tous mes BC';
          this.isListAValide = false;
          break;
        }
        case 's_litige': {
          this.title = this.title + ': en cours de litige';
          this.isListAValide = false;
          break;
        }
        case 'mes_Bc_litige': {
          this.title = this.title + ': mes BC en cours de litige';
          this.isListAValide = false;
          break;
        }
        default: {
          this.title = this.title + '';
          this.isListAValide = false;
        }
      }
      this.bcService.getFiltredBc(this.filtreData).subscribe((data: SimpleQueryResponse<BcModel>) => {
        this.simpleQueryBcResponse = data;
        this.bcList = data.objets;
      });
    });
  }

  load(): void {
      this.userService.getAllCreateur('BC').subscribe(objs => this.users = objs);
      this.userService.getAllValideur('BC').subscribe(objs => { this.validors = objs; });
      this.societeService.getAllForBc().subscribe(objs => { this.societes = objs; });
  }

  getSelectedBcs(event: BcModel[]): void {
    this.selectedBcsChild = event;
    if (this.isCreateBp) {
      if (event.length !== 0) {
        const bclignes: BcLineModel[] = [];
        event.forEach(bc => {
          bc.bcLines.forEach(bcligne => {
            bclignes.push(bcligne);
          });
        });
        this.livraisonBcService.getLivByBcligne(bclignes).subscribe(livs => {
          this.bp = new BpModel(this.selectedBcsChild , livs);
        });
      } else {
        this.bp = null;
      }
    }
  }

  goToCreateBP(): void {
    this.bpComponentsService.createBp(this.bp);
  }

  memorize(): void {
    this.bpComponentsService.memorizeBp(this.bp).subscribe((data: any) => {
      this.bp = data;
      this.router.navigate(['brouillon-bp/' + this.bp.id]);
    });
  }

  validation(): Observable<number> {
    let i = 0;
    const nb = new BehaviorSubject<number>(0);
    for (const bc of this.selectedBcsChild) {
      const bcvalidator: BcValidationModel = new BcValidationModel(bc);
      this.bcService.validateBc(bcvalidator).subscribe(_ => {
        i++;
        nb.next(i);
      }, (error) => -1);
    }
    return nb.asObservable();
  }

  onValidationBcs(): void {
    const dialogRef = this.dialog.open(ModalChargementComponent, {
      disableClose: true,
      data: {
        observable: this.validation(),
        total: this.selectedBcsChild.length,
        result: true
      }
    });
    dialogRef.afterClosed().subscribe(_ => {
      this.ngOnInit();
    });
  }

  onExport(): void {
    const dialogRef = this.dialog.open(SpinnerModalComponent);
    this.bcService.exportBcs(this.filtreData).subscribe((res: BlobPart)  => {
      const blob = new Blob([new Uint8Array([0xEF, 0xBB, 0xBF]), res], {type: 'text/csv;charset=utf-8'});
      saveAs(blob, 'Export_BC_' + new Date().toISOString() + '.csv');
      dialogRef.close();
    }, (error) => dialogRef.close());
  }

  stringifyBool(flags: boolean[]): string[] {
    const response = [];
    flags.forEach(flag => {
      if (flag) {
        response.push('Total');
      } else {
        response.push('Aucun');
      }
    });
    return response;
  }

  parseBool(flags: string[]): boolean[] {
    const response = [];
    flags.forEach(flag => {
      switch (flag) {
        case 'Total':
          response.push(true);
          break;
        case 'Aucun':
          response.push(false);
          break;
      }
    });
    return response;
  }

  openModalFournisseur(): void {
    this.dialog.open(ModalRechercheFournisseurComponent, {
      disableClose: true,
      data: {
        idSociete: this.filtreData.idSociety
      }
    }).afterClosed().subscribe((res: FournisseurModel) => {
      if (res) {
        this.filtreData.bcFourn = res;
        this.filtreData.pageNumber = 0;
        this.onChange(res.code + "-" + res.libelle)
      }
    });
  }
}
